<template>
  <div>
    <!-- override the description field so that is displays as a textarea -->
    <v-textarea
      v-if="fieldDef.type === 'text' && fieldDef.label === 'description'"
      v-model="value"
      :label="fieldLabel"
      v-bind="customProps"
      no-resize
      rows="3"
      auto-grow
      :rules="fieldRules"
    />
    <!-- Text || Number field -->
    <v-text-field
      v-else-if="fieldDef.type === 'text' || fieldDef.type === 'number'"
      v-model="value"
      :type="fieldDef.type"
      :label="fieldLabel"
      v-bind="customProps"
      :rules="fieldRules"
    />
    <!-- Date field-->
    <NodeDatePicker
      v-else-if="fieldDef.type === 'date'"
      :value.sync="value"
      :label="fieldLabel"
      min="0000-01-01"
      class="mt-n2"
    />
    <!-- Checkbox field -->
    <v-checkbox
      v-else-if="fieldDef.type === 'checkbox'"
      v-model="value"
      :label="fieldLabel"
      hide-details
      v-bind="customProps"
      :rules="fieldRules"
    />
    <!-- List of MultipleChoice feild -->
    <v-select
      v-else-if="fieldDef.type === 'list'"
      v-model="value"
      :label="fieldLabel"
      :items="fieldDef.options"
      :menu-props="{ light: true, maxHeight: 400 }"
      v-bind="customProps"
      :chips="fieldDef.multiple"
      :deletable-chips="fieldDef.multiple"
      :multiple="fieldDef.multiple"
      :rules="fieldRules"
      height="56px"
      hide-details
    />
    <!-- Array field -->
    <v-row
      v-else-if="fieldDef.type === 'array'"
      no-gutters
    >
      <v-col v-for="(_, i) in value" :key="`${fieldDef.key}-${i}`" :class="getArrayClass(i)" :cols="mobile ? '12' : '6'">
        <v-text-field
          v-model="value[i]"
          :label="`${fieldLabel} (${i + 1})`"
          append-icon="mdi-delete"
          @click:append="removeItem(i)"
          v-bind="customProps"
          :rules="fieldRules"
        />
      </v-col>
      <v-col cols="12" >
        <AddButton
          :label="fieldLabel"
          align="start"
          justify="start"
          row
          color="white"
          background="#666"
          width="50px"
          class="pl-1"
          @click="addEmptyItem"
        />
      </v-col>
    </v-row>

  </div>
</template>

<script>
import AddButton from '@/components/AddButton.vue'
import NodeDatePicker from '@/components/NodeDatePicker.vue'

export default {
  name: 'CustomField',
  props: {
    fieldDef: Object,
    fieldValue: [String, Number, Boolean, Array, Object],
    submitted: Boolean
  },
  components: {
    AddButton,
    NodeDatePicker
  },
  data () {
    return {
      value: null,
      rules: [v => (!!v && v.length > 0) || 'required field']
    }
  },
  watch: {
    fieldValue: {
      immediate: true,
      deep: true,
      handler (val) {
        this.value = val
      }
    },
    value: {
      immediate: true,
      deep: true,
      handler (val) {
        this.$emit('update:fieldValue', val)
      }
    }
  },
  computed: {
    customProps () {
      return {
        hideDetails: 'auto',
        placeholder: ' ',
        light: true,
        outlined: true
      }
    },
    mobile () {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm
    },
    fieldLabel () {
      return this.fieldDef.required ? this.fieldDef.label + '*' : this.fieldDef.label
    },
    fieldRules () {
      // NOTE: here we are disabling the form validation until submitted=true.
      // this is to stop the form showing errors before the user has submitted
      // the form
      return !this.submitted ? [] : this.fieldDef.required ? this.rules : []
    }
  },
  methods: {
    // formatting based on position of text fields
    getArrayClass (i) {
      if (this.mobile) return 'pb-2'

      // custom classes for text fields in an array
      return {
        'pl-0 pr-1 pb-2': i % 2 === 0, // for text fields on the left
        'pl-1': ((i % 2) !== 0) // for text fields on the right
      }
    },
    addEmptyItem () {
      this.value.push('')
    },
    removeItem (i) {
      this.value.splice(i, 1)
    }
  }
}
</script>
